"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AudioInputFailed = require("./AudioInputFailed");
Object.keys(_AudioInputFailed).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AudioInputFailed[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AudioInputFailed[key];
    }
  });
});